import{useContext}from'react';import{I18nContext}from'@bingads-webui-react/i18n-context';export var useI18n=function useI18n(){return useContext(I18nContext);};